const csvProcessor = {
  noProjectMessage: "Please select a project before processing CSV data.",
  heading: "CSV Data Processing",
  projectLabel: "Project:",
  dropzone: {
    clickOrDrag: "Click to select or drag CSV file here",
    hint: "CSV files only, max 50MB",
  },
  fileInfo: {
    summary: "{{columns}} columns, {{rows}} rows",
    changeFileButton: "Change file",
  },
  columnSelection: {
    heading: "Select Columns to Pseudonymize",
    selectAllButton: "Select all",
    clearButton: "Clear",
    selectedSummary: "Selected: {{selected}} of {{total}} columns",
  },
  actions: {
    processing: "Processing...",
    deidentifyButton: "Pseudonymize {{count}} Columns",
    reverseButton: "Reverse (Admin)",
  },
  results: {
    heading: "Processed Result",
    downloadButton: "Download CSV",
    rowsCaption_one: "{{count}} row",
    rowsCaption_other: "{{count}} rows",
    showingFirstCaption: "Showing first {{shown}} of {{total}} rows",
  },
  messages: {
    processedWithWarningsSuffix: "(Processed with column warnings)",
  },
  errors: {
    csvOnly: "Please upload a CSV file only",
    fileTooLarge: "File size must be less than 50MB",
    selectFileAndColumns:
      "Please upload a CSV file and select columns to pseudonymize",
    validationOrProcessingFailed: "Validation or pseudonymization failed",
    processingFailed: "Pseudonymization failed",
    reverseNotAllowed: "Reverse operation is only available for administrators",
    selectFileAndColumnsReverse:
      "Please upload a CSV file and select columns to reverse",
    reverseFailed: "Reverse operation failed",
  },
};

export default csvProcessor;
